export const RESULT_BADGE_VISIBLE_MS = 5000;

export type TabTaskStatus = 'idle' | 'executing' | 'success' | 'fail' | 'interrupt';
export type Visibility = 'visible' | 'hidden';
export type DismissPlan = 'keep' | 'after-visible-ms' | 'on-focus' | 'now';

export function isResultStatus(status: TabTaskStatus): boolean {
  return status === 'success' || status === 'fail' || status === 'interrupt';
}

export function planOnStatusEnter(status: TabTaskStatus, visibility: Visibility): DismissPlan {
  if (status === 'executing' || status === 'idle') {
    return 'keep';
  }
  if (!isResultStatus(status)) {
    return 'keep';
  }
  return visibility === 'visible' ? 'after-visible-ms' : 'on-focus';
}

export function planOnVisibilityChange(
  status: TabTaskStatus,
  visibility: Visibility,
): DismissPlan {
  if (!isResultStatus(status)) {
    return 'keep';
  }
  if (visibility === 'visible') {
    return 'now';
  }
  return 'on-focus';
}
